import React from 'react';

const VisualizationPanel = ({ buttons }) => {
  return (
    <div style={{ 
      width: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      height: '100%' 
    }}>

      {/* Dots at the bottom */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
        marginTop: '20px'
      }}>
        {buttons.map((_, index) => (
          <div
            key={index}
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: '#f97316',
              cursor: 'pointer'
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default VisualizationPanel;
